// extracted by mini-css-extract-plugin
export default {"leftNavHeader":"left-nav_leftNavHeader__+Hasi"};